import { render, staticRenderFns } from "./create-or-edit.vue?vue&type=template&id=03d70028&scoped=true&"
import script from "./create-or-edit.vue?vue&type=script&lang=js&"
export * from "./create-or-edit.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit.vue?vue&type=style&index=0&id=03d70028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d70028",
  null
  
)

export default component.exports